import createConfigAccount from '.';
import { configAccountRoutes } from './routes';

export const createConfigAccountPage = () => {
  const ConfigAccount = createConfigAccount();

  const ConfigAccountPage = configAccountRoutes;
  return () => <ConfigAccountPage ConfigAccount={ConfigAccount} />;
};
